export const purpurBreakpointSm = "0px";
export const purpurBreakpointMd = "600px";
export const purpurBreakpointLg = "1024px";
export const purpurBreakpointXl = "1440px";
export const purpurBreakpointRelativeSm = "0em";
export const purpurBreakpointRelativeMd = "37.5em";
export const purpurBreakpointRelativeLg = "64em";
export const purpurBreakpointRelativeXl = "90em";
